<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Please Don't Eat the Daisies</title>
<link href="../style/9781504055741.css" rel="stylesheet" type="text/css"/>
<p class="ded"><span class="bold"><em class="italic">For my severest critic</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?6c7ab25b